import InstrumentsPage from '@/pages/Instruments';
import { createLazyFileRoute } from '@tanstack/react-router';

export const Route = createLazyFileRoute('/instruments/')({
  component: InstrumentsPage,
});
